import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UISpinnerComponent } from './ui-spinner.component';

@NgModule({
  declarations: [
    UISpinnerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    UISpinnerComponent
  ]
})
export class UISpinnerModule { }
